<template>
    <div class="main">
        <div class="body-content">
            <h3 style="margin: 0;">Shipping Bills</h3>
            <div class="form-group">
                <div class="form-item">
                    <label for="partyname">Party *</label>
                    <v-select :clearable="false" tabindex="0" placeholder="Select Party Name" id="partyname"
                        v-model="newContainer.partyName" :options="party" label="short_name"
                        :reduce="party => party.autoid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="vcnname">VCN No *</label>
                    <v-select :clearable="false" id="vcnname" v-model="newContainer.vcnID" :options="vcns"
                        @v-on:change="FillVCNDetails" label="vcnName" :reduce="vcn => vcn.vcnID" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="vesselName">Vessel *</label>
                    <v-select :clearable="false" id="vesselName" placeholder="Select Vessel"
                        v-model="newContainer.vesselID" ref="vesselName" :options="vessel" label="Name"
                        :reduce="vessel => vessel.Vesselid" selectOnTab="True" />
                </div>

                <div class="form-item">
                    <label for="voyageName">Voyage *</label>
                    <v-select :clearable="false" id="voyageName" v-model="newContainer.VoyId" :options="voyage"
                        label="Name" :reduce="voyage => voyage.Voyageid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="location">Location:</label>
                    <v-select :clearable="false" id="location" v-model="newContainer.locID" :options="location"
                        label="Name" :reduce="location => location.locationid" selectOnTab="True" />
                </div>
                <div class="form-item" style="width: 10%;">
                    <label for="fromdate">From Date </label>
                    <input type="text" id="fromdate" v-model="newContainer.fromdate" placeholder="dd/mm/yyyy"
                        v-on:blur="checkIsDate()" style="width: 100px;" />
                </div>
                <div class="form-item" style="width: 10%;">
                    <label for="todate">To Date </label>
                    <input type="text" id="todate" v-model="newContainer.todate" placeholder="dd/mm/yyyy"
                        v-on:blur="checkIsToDate()" style="width: 100px;" />
                </div>
            </div>
            <div class="form-group">
                <div class="form-item" style="width: 90%;">
                    <label for="contnumber">container's:</label>
                    <textarea id="contnumber" style="width: 100%;" v-model="newContainer.contnumber"
                        placeholder="Generating Report for Specific Container(s)..." rows="3"></textarea>
                </div>
            </div>
            <div class="form-group">
                <div class="form-item" style="margin-top: 15px;">
                    <button type="button" class="excel-button" @click="getTablesData" :disabled="isSubmitting">Show</button>
                </div>
            </div>

            <div class="form-group" v-if="rows.length > 0">
                <div class="form-item1">
                    <RevoGrid hide-attribution :source="rows" :columns="columns" :theme="compact"
                        @afteredit="onCellEdit" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import * as cs from '../assets/js/commonscript.js'
import RevoGrid from '@revolist/vue3-datagrid'

export default {
    components: {
        VSelect,
        RevoGrid,
    },
    data() {
        return {
            party: JSON.parse(localStorage.getItem('party')),
            vessel: JSON.parse(localStorage.getItem('vessel')) || [],
            voyage: JSON.parse(localStorage.getItem('voyage')) || [],
            location: JSON.parse(localStorage.getItem('Area')) || [],
            vcns: [],
            columns: [
                { prop: 'sno', name: 'S.No' },
                { prop: 'sbno', name: 'Shipping Bill', sortable: true },
                { prop: 'sbdate', name: 'SB Date', sortable: true },
                {
                    prop: 'contnumber', name: 'Container', sortable: true, size: 110,
                    cellProperties: ({ model }) => {
                        return {
                            style: {
                                color: model.contnumberInvalid ? 'red' : ''
                            },
                        }
                    }
                },
                { prop: 'iec', name: 'IEC' },
                { prop: 'gstn', name: 'GSTN', size: 120 },
                { prop: 'pcin', name: 'PCIN', size: 150 },
                { prop: 'type_of_package', name: 'Type Of Package' },
                { prop: 'no_of_package', name: 'No On Package' },

            ],
            rows: [],
            isSubmitting: false,
            newContainer: {
                partyName: 0,
                applicantID: 0,
                accountID: 0,
                vesselID: 0,
                vesselname: '',
                consign: '',
                vcnID: 0,
                VoyId: 0,
                voyage: '',
                locID: 0,
                contnumber: '',
                fromdate: '',
                todate: ''
            }
        }
    },
    created() {
        this.fetchVcnList();
    },
    watch: {
        'newContainer.vcnID'(value) {
            this.FillVCNDetails(value)
        }
    },
    methods: {
        checkIsDate() {
            if (this.newContainer.fromdate != '') {
                if (cs.isvalidDate(this.newContainer.fromdate) == false) {
                    useToast().error('Invalid From Date');
                }
            }
        },
        checkIsToDate() {
            if (this.newContainer.todate != '') {
                if (cs.isvalidDate(this.newContainer.todate) == false) {
                    useToast().error('Invalid To Date');
                }
            }
        },
        async fetchVcnList() {
            const token = localStorage.getItem('access_token');
            try {
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const response = await axios.get('/active_vcn_list/', config);
                var data = response.data[2]
                data.push({ "vcnID": 0, "vcnName": "Select VCN", "vesselID": 0, "import_voyage": 0, "export_voyage": 0, "MlocID": 0, "ImpRotNo": "", "ImpRotDate": null, "ExpRotNo": "", "ExpRotDate": null, "BerthDate": null, "EgmDate": null, "SailDate": null, "IsSail": 0, "vesselLocation": 0, "created_by": 0, "CreateDate": null, "last_modified_by": 0, "ModiDate": null, "VesselName": "", "import_voyageName": "", "export_voyageName": "", "area": "", "Vesselarea": "" })
                this.vcns = data;
            } catch (error) {
                console.error('Error fetching VCN list:', error);
                this.error = 'Error fetching VCN list. Check console for details.';
            }
        },
        FillVCNDetails(value) {
            //const vcnID = this.newContainer.vcnID
            const selvcn = this.vcns.find(vcn => vcn.vcnID === value);
            if (selvcn.vcnID !== 0) {
                if (selvcn) {
                    this.newContainer.vesselID = selvcn.vesselID
                    this.newContainer.VoyId = selvcn.export_voyage
                    this.newContainer.voyage = selvcn.export_voyageName
                    this.newContainer.locID = selvcn.MlocID
                }
            }
        },
        updateApplicantAccountIds(value) {
            const AppAcc = cs.GetAppAccFromParty(value)
            this.newContainer.applicantID = AppAcc.applicantid
            this.newContainer.accountID = AppAcc.accountid
        },
        async getTablesData() {
            if (this.isSubmitting) return;
            
            if ((this.newContainer.partyName === 0 || this.newContainer.vesselID === 0 || this.newContainer.VoyId === 0) && this.newContainer.contnumber === '' && (this.newContainer.fromdate === '' || this.newContainer.todate === '')) {
                {
                    useToast().error("Please fill all required fields");
                    return;
                }
            }
            
            this.isSubmitting = true;
            try {
                if (this.newContainer.partyName !== 0) {
                    this.updateApplicantAccountIds(this.newContainer.partyName)
                }
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                        'Content-Type': 'multipart/form-data'
                    },
                };
                const data = new FormData();
                const transdt = JSON.stringify(this.newContainer)
                data.append('transaction', transdt)
                const response = await axios.post(`/sb_uploadedlist`, data, config);
                console.log(response)
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                    this.rows = [];
                    return;
                } else {
                    useToast().success("Data fetched successfully");
                    //this.rows = response.data[2];
                    const regex = /^[A-Za-z]{4}\d{7}$/;
                    this.rows = response.data[2].map((row, idx) => ({
                        sno: idx + 1,
                        ...row,
                        contnumberInvalid: !regex.test(row.contnumber) // Add a flag for invalid container
                    }));
                    //console.log(this.rows)
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                useToast().error('An error occurred while fetching data');
                this.rows = [];
            } finally {
                this.isSubmitting = false;
            }
        },
        async onCellEdit(event) {
            try {
                var { model, prop, val, row } = event.detail;
                //console.log(model, prop, val);
                //console.log('Row not found or invalid:', model, prop);
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                        'Content-Type': 'multipart/form-data'
                    },
                };
                const data = new FormData();
                var modeldata = model
                modeldata.prop = prop;
                var transdt = JSON.stringify(model)
                data.append('prop', prop);
                data.append('transaction', transdt)
                const response = await axios.post('/update_sb', data, config);
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success("Updated successfully");
                }
                if (prop === 'contnumber') {
                    const regex = /^[A-Za-z]{4}\d{7}$/;
                    //this.rows[model].contnumberInvalid = !regex.test(val);
                    const updatedRow = {
                        ...this.rows[row],
                        [prop]: val,
                        contnumberInvalid: !regex.test(val)
                    };
                    this.rows.splice(row, 1, updatedRow);
                }
            } catch (error) {
                console.error('Error updating cell:', error);
                useToast().error('An error occurred while updating the cell');
            }
        },
    }
}
</script>
<style scoped>
.invalid-contnumber {
    background-color: #ffcccc !important;
}

.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 30%;
}

.form-item1 {
    width: 90%;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    opacity: 0.6;
}
</style>